/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { TextField } from '@material-ui/core'

const styles = theme => ({

})

class FlexInput extends Component {
    state = {
        value : null,
        error : false,
        helper_text : "",
        mandatory: false
    }

    inputRef = React.createRef()

    componentWillMount () {
        console.log("Type: ", this.props.instance.component)
        console.log("ID: ", this.props.instance.id)
        let value
        if (this.getValueType(this.props.instance.component) === 'number') {
            value = Number(this.props.instance.value.number)
        } else {
            value = this.props.instance.value.text
        }

        this.setState({...this.state, value : value}, () => { this.setErrorAndHelperText(); this.getMandatory()})
    }

    componentDidUpdate (prevProps, prevState) {
        let value
        if (this.getValueType(this.props.instance.component) === 'number') {
            value = Number(this.props.instance.value.number)
        } else {
            value = this.props.instance.value.text
        }
        if (prevState.value === this.state.value) {
            if (value !== this.state.value) {
                this.inputRef.current.focus()
                this.setState({...this.state, value : value})
            }
        }
    } 

    getParam = (param_name, value_type) => {
        let parameter = null

        if (this.props.instance.component_params !== null) {
            this.props.instance.component_params.map(param => {
                if (param.name === param_name) {
                    parameter = param.value[value_type]
                }
            })
        }

        return parameter
    }

    setErrorAndHelperText = () => {
        let config_error = this.getParam("error", "boolean")
        let helper_text = this.getParam("helper_text", "text")
        let error_message = this.getParam("error_message", "text") !== null ? this.getParam("error_message", "text") : this.getParam("helper_text", "text")

        if (config_error !== null) {
            this.setState({...this.state, 
                error : config_error, 
                helper_text : config_error === true ? error_message : helper_text
            })
        } else {
            this.setState({
                ...this.state,
                helper_text : helper_text
            })
        }
    }

    getErrorAndHelperText = () => {
        let state_error = this.state.error

        if (state_error === true) {
            this.setState({...this.state, error : true}, () => this.getHelperText())
        }
    }

    getHelperText = () => {
        let helper_text
        if (this.state.error === false) {
            helper_text = this.getParam("helper_text", "text")
        } else {
            helper_text = "Invalid entry"
        }

        this.setState({...this.state, helper_text : helper_text})
    }

    getMandatory = () => {
        let mandatory = this.getParam("mandatory", "boolean");
        this.setState({...this.state, mandatory: mandatory});
    }

    handleChange = (event) => {
        if (this.getValueType(this.props.instance.component) === "number") {
            let value = event.target.value
            this.setState({...this.state, value : (value === '0' || value) ? Number(value) : ''})
        } else {
            this.setState({...this.state, value : event.target.value})
        }
    }

    getValueType = (component) => {
        switch (component) {
            case "text" :
                return "text"
            
            case "number" :
                return "number"

            case "email" :
                return "text"

            case "password" :
                return "text"

            case "url" :
                return "text"

            default:
                return "text"
        }
    }

    validateAndPush = () => {
        console.log('Validating! ', this.props.instance.id)
        if (this.validate(this.props.instance.component)) {
            this.setState({...this.state, error : false}, () => {
                this.getHelperText()
                this.props.update_value(this.props.instance.id, this.getValueType(this.props.instance.component), this.state.value)
            })
        } else {
            this.setState({...this.state, error : true}, () => {
                this.getHelperText()
            })
        }
    }

    validate = (validation_type) => {
        switch (validation_type) {
            case "email":
                return this.validateEmail()
            default:
                return true
        }
    }

    validateEmail = () => {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.value)) {
            return true
        } else {
            return false
        }
    }

    validateUrl = () => {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
            '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(this.state.value);
    }



    render() {
        const { classes } = this.props
        return (
            <TextField
                ref = {this.inputRef}
                style = {{width : '100%'}}
                variant = 'standard'
                type = {this.props.instance.component}
                label = {this.props.instance.name}
                required = {this.state.mandatory}
                placeholder = {this.getParam("place_holder", "text")}
                helperText = {this.state.helper_text}
                value = {this.state.value}
                onChange = {this.handleChange}
                onBlur = {this.validateAndPush}
                error = {this.state.error}
                disabled = {this.props.disabled}
                multiline = {this.getParam("multi_line", "boolean")}
                rowsMax = {this.getParam("max_rows", "number")}
            />
        );
    }
}

export default withStyles(styles)(FlexInput)